// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';
// @ts-ignore
import {Settings_context} from '../settings_ctx';
import {Cards, i_card, i_cls_obj} from '../ui/cards';
import type {i_button_props} from '../../../shared/button';
import {Editor} from '../../../shared/editor/editor';
import styles from './contact_us_cards.module.less';

export const Contact_us_cards = ()=>{
    const {theme} = useContext(Settings_context);
        const card_btn: Partial<i_button_props> = {
        color: 'white',
        size: 'xs',
        cls: styles.card_btn,
    };
    const cards: i_card[] = [
        {
            id: 'support',
            title: 'Need Tech Support?',
            text: <Fragment>
              Visit our <Link className={theme.link}
              to="/support">Help Center</Link> or get in touch with our
              friendly support team.
            </Fragment>,
            btn: {
                ...card_btn,
                caption: 'Submit a Request',
                to: '/premium_support',
            },
        },
        {
            id: 'feedback',
            title: 'General Feedback',
            text: 'Please share your thoughts with us.',
            btn: {
                ...card_btn,
                caption: 'Get in touch',
                to: '/premium_support',
            },
        },
        {
            id: 'faq_payment',
            title: 'Payment Help',
            text: 'For all billing related queries, feel free to contact us',
            btn: {
                ...card_btn,
                caption: 'Payment Help page',
                to: '/payment_help',
            },
        },
        {
            id: 'press',
            title: 'Press area',
            text: <Fragment>
              Working on a story and need expert opinion?<br/>
              <a className={theme.link}
              href="mailto:media@hola.org">media@hola.org</a>
            </Fragment>,
            btn: {
                ...card_btn,
                caption: 'Media page',
                to: '/media',
            },
        },
    ];
    const cards_cls: i_cls_obj = {
        container: styles.cards,
        title: cn(theme.p2, theme.bold),
        text: cn(theme.p3, theme.reg),
        card: styles.card,
    };
    return <Cards cards={cards} cls={cards_cls}/>;
};

interface i_contact_us_cards_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const Contact_us_cards_editor = (
{value, on_change}: i_contact_us_cards_editor_props)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
